var map = {
	"./add-comment.svg": "a79f",
	"./add-user.svg": "8e77",
	"./address.svg": "0a60",
	"./attachment.svg": "31dd",
	"./bell.svg": "24d1",
	"./check-circle.svg": "bfef",
	"./check.svg": "8a2e",
	"./checked.svg": "e3fa",
	"./clipboard.svg": "cecd",
	"./clock.svg": "c2be",
	"./code.svg": "04c7",
	"./contest.svg": "e3ed",
	"./criteria.svg": "a051",
	"./csv.svg": "51a9",
	"./dashboard.svg": "0fbd",
	"./dealers.svg": "7c19",
	"./doc.svg": "b8be",
	"./docx.svg": "606d",
	"./dots.svg": "2476",
	"./down.svg": "fcc9",
	"./download.svg": "1574",
	"./edit-message.svg": "ffe7",
	"./edit.svg": "5e21",
	"./email.svg": "9f32",
	"./export.svg": "6849",
	"./import.svg": "31c9",
	"./jpeg.svg": "bd1b",
	"./jpg.svg": "972f",
	"./logout.svg": "b20f",
	"./medal.svg": "f3b9",
	"./message.svg": "df34",
	"./messages.svg": "3c34",
	"./money.svg": "c547",
	"./password.svg": "e6072",
	"./pdf.svg": "3da9",
	"./plus.svg": "1d3e",
	"./png.svg": "9609",
	"./ppt.svg": "e8a1",
	"./pptx.svg": "940d",
	"./profile.svg": "2890",
	"./ranking.svg": "ae98",
	"./rating.svg": "814d",
	"./receipt.svg": "e818",
	"./restore.svg": "1baf",
	"./right.svg": "512e",
	"./roles.svg": "7f57",
	"./settings.svg": "d767",
	"./shield.svg": "32bd",
	"./star.svg": "ce9d",
	"./trash.svg": "1264",
	"./txt.svg": "0f90",
	"./upload.svg": "fe85",
	"./users.svg": "b770",
	"./view.svg": "8d5c",
	"./warning.svg": "843e",
	"./xls.svg": "dfa4",
	"./xlsx.svg": "3f2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcb7";